import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface NivelRiesgoPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface NivelRiesgo {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface NivelRiesgoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class NivelRiesgoService {
  private readonly apiUrl = `${environment.apiUrl}/api/nivel_riesgo`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<NivelRiesgo[]> {
    return this.http.get<NivelRiesgo[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<NivelRiesgo> {
    return this.http.get<NivelRiesgo>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: NivelRiesgoPayload
  ): Observable<NivelRiesgoResponse> {
    return this.http.post<NivelRiesgoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<NivelRiesgoPayload>
  ): Observable<NivelRiesgoResponse> {
    return this.http.put<NivelRiesgoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<NivelRiesgoResponse> {
    return this.http.put<NivelRiesgoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<NivelRiesgoResponse> {
    return this.http.put<NivelRiesgoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}